/* eslint-disable */
import moment from 'moment';
import { ACCESS_LEVEL, ASSETTYPE, ENTITYNAME, LOCALSTORAGE_KEY, MEDIACATEGORIES, PLATFORMTYPE, TOAST_TYPES } from '../constant/constant';
import { utility } from '../utility/utilityProvider';
import * as API from '../API/api';
import { useTranslation } from '../../locale/useTranslation';
import ToastNotification from '../../components/ToastNotification';

export const DataHelper = {};
DataHelper.getNewAssetId = async (content = {}, isSaveNextnumber = false, media = null) => {

  const lang = useTranslation();

  const updatedContent = await API.getAndSaveNextNumber(content.SID, { ...content, isSaveNextnumber: isSaveNextnumber, media: media });
  if (!updatedContent.success) {
    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.error_while_generating_house_number_media_episode_error_message });
    return "";
  }

  return updatedContent?.data?.HouseNumber ?? "";

}

DataHelper.saveSeriesEntity = (dataItem = {}, mediaCategory = [], isOttAsset, selectedImageUrl, castAndCrew = []) => {

  let mediaCategoryData = mediaCategory.find((obj) => obj.SID == MEDIACATEGORIES.Series);

  let finalData = {
    _id: dataItem?._id,
    SID: dataItem?.SID,
    Title: dataItem?.Title,
    Content: dataItem?.Content && Object.keys(dataItem?.Content).length > 0 ? { _id: dataItem?.Content?._id, SID: dataItem?.Content?.SID, Description: dataItem?.Content?.Description } : {},
    Description: dataItem?.Description,
    MediaCategory: mediaCategoryData ? { _id: mediaCategoryData?._id, Description: mediaCategoryData?.Description, SID: mediaCategoryData?.SID, isLong: mediaCategoryData?.isLong } : {},
    //MEDIA SUB CATEGORY TYPE
    MediaSubCategoryType: dataItem?.MediaSubCategoryType ? { _id: dataItem?.MediaSubCategoryType?._id, Description: dataItem?.MediaSubCategoryType?.Description, SID: dataItem?.MediaSubCategoryType?.SID, MediaCategorySID: dataItem?.MediaSubCategoryType?.MediaCategorySID } : {},
    //END
    ImageUrl: selectedImageUrl,
    // Synopsis: typeof dataItem?.Synopsis === 'string' ? dataItem?.Synopsis : dataItem?.Synopsis?.length > 0 ? dataItem?.Synopsis.map(s=> {
    //   return {
    //     Synopsis: s.Synopsis,
    //     Language: s.Language?._id ? { _id: s.Language?._id, Description: s.Language?.Description, ISOCode: s.Language?.ISOCode } : {},
    //     Type: s.Type
    //   }
    // }) : [],
    Synopsis: dataItem?.Synopsis,
    SeriesSynopsis: dataItem?.SeasonSynopsis?.length > 0 ? dataItem.SeasonSynopsis.map(s => {
      return {
        Synopsis: s.Synopsis,
        Language: s.Language?._id ? { _id: s.Language?._id, Description: s.Language?.Description, ISOCode: s.Language?.ISOCode } : {},
        Type: s.Type
      }
    }) : [],
    CastAndCrew: castAndCrew?.length > 0 ? castAndCrew?.map((x) => {
      return {
        Name: x?.Name,
        CastType: { _id: x?.CastType?._id, Description: x?.CastType?.Description },
        Language: {
          _id: x?.Language?._id,
          ISOCode: x?.Language?.ISOCode,
          Description: x?.Language?.Description
        }
      }
    }) : [],
    AssetId: dataItem?.AssetId,
    PGRating: dataItem?.PGRating && Object.keys(dataItem?.PGRating).length > 0 ? {
      _id: dataItem?.PGRating?._id,
      Description: dataItem?.PGRating?.Description
    } : {},
    Languages: dataItem?.Languages?.length > 0 ? dataItem.Languages.map(x => {
      return {
        _id: x._id,
        Description: x.Description,
        ISOCode: x.ISOCode
      }
    }) : [],
    IsOttAsset: isOttAsset ?? false,
    IsLive: dataItem?.IsLive ?? false,
    Keywords: dataItem?.Keywords,
    SeasonsCount: dataItem?.SeasonsCount ?? 0,
    ProductionYear: dataItem?.ProductionYear,
    Archive: dataItem?.Archive ?? false,
    Genres: dataItem?.Genres?.length > 0 ? dataItem.Genres.map(x => {
      return {
        _id: x._id,
        Description: x.Description,
      }
    }) : [],
    SubGenres: dataItem?.SubGenres?.length > 0 ? dataItem.SubGenres.map(x => {
      return {
        _id: x._id,
        Description: x.Description,
      }
    }) : [],
    Categories: dataItem?.Categories && dataItem?.Categories?.length > 0 ? dataItem?.Categories?.map((item) => {
      return {
        _id: item?._id,
        Name: item?.Name,
        parent: item?.parent
      }
    }) : [],
    Transmission: dataItem?.Transmission?._id ? dataItem?.Transmission?._id : null,
    MediaType: dataItem.MediaType && Object.keys(dataItem.MediaType).length > 0 ? { _id: dataItem.MediaType?._id, Description: dataItem.MediaType?.Description, SID: dataItem.MediaType?.SID } : {},
    MediaSubType: dataItem.MediaSubType && Object.keys(dataItem.MediaSubType).length > 0 ? { _id: dataItem.MediaSubType?._id, Description: dataItem.MediaSubType?.Description, SID: dataItem.MediaSubType?.SID } : {},
    Provider: dataItem.Provider?._id ? { _id: dataItem.Provider?._id, Description: dataItem.Provider?.Description } : {},
    Extension: dataItem?.Extension ?? {},
    dynamicField: dataItem?.dynamicField ?? {},
    DubbedLanguages: dataItem?.DubbedLanguages?.length > 0 ? dataItem.DubbedLanguages.map(x => {
      return {
        _id: x._id,
        Description: x.Description,
        ISOCode: x.ISOCode
      }
    }) : [],
    SeriesCode: dataItem?.SeriesCode,
    WorkingTitle: dataItem?.WorkingTitle || DataHelper.getWorkingTitle({
      customTitle2: dataItem?.CustomTitle?.Title2,
      title: dataItem?.Title,
      pgRating: dataItem?.PGRating?.Description,
      dealReference: dataItem?.DealReference
    }),
    CustomTitle: dataItem?.CustomTitle,
    ShortTitle: dataItem?.ShortTitle,
    CustomShortTitle: dataItem?.CustomShortTitle,
    CustomDescription: dataItem?.CustomDescription,
    DealReference: dataItem?.DealReference,
    checkDuplicate: true,
    query: [["Title", "=", dataItem?.Title], ["Archive", "=", false]]
  }
  return finalData;
}

DataHelper.saveSeasonEntity = (dataItem = {}, mediaCategory = [], isOttAsset, selectedSeriesId, selectedImageUrl, castAndCrew = []) => {

  let mediaCategoryData = mediaCategory.find((obj) => obj.SID == MEDIACATEGORIES.Season);
  let finalData = {
    _id: dataItem?._id,
    SID: parseInt(dataItem?.SID),
    Title: dataItem?.Title,
    Content: dataItem?.Content && Object.keys(dataItem?.Content).length > 0 ? { _id: dataItem?.Content?._id, SID: dataItem?.Content?.SID, Description: dataItem?.Content?.Description } : {},
    Description: dataItem?.Description,
    MediaCategory: mediaCategoryData?._id ? { _id: mediaCategoryData?._id, Description: mediaCategoryData?.Description, SID: mediaCategoryData?.SID, isLong: mediaCategoryData?.isLong } : {},
    //MEDIA SUB CATEGORY TYPE
    MediaSubCategoryType: dataItem?.MediaSubCategoryType?._id ? { _id: dataItem?.MediaSubCategoryType?._id, Description: dataItem?.MediaSubCategoryType?.Description, SID: dataItem?.MediaSubCategoryType?.SID, MediaCategorySID: dataItem?.MediaSubCategoryType?.MediaCategorySID } : {},
    //END
    ImageUrl: selectedImageUrl ?? "",
    SeasonNumber: dataItem?.SeasonNumber ? parseInt(dataItem?.SeasonNumber) : 1,
    Synopsis: dataItem?.Synopsis,
    SeasonSynopsis: dataItem?.SeasonSynopsis?.length > 0 ? dataItem.SeasonSynopsis.map(s => {
      return {
        Synopsis: s.Synopsis,
        Language: s.Language?._id ? { _id: s.Language?._id, Description: s.Language?.Description, ISOCode: s.Language?.ISOCode } : {},
        Type: s.Type
      }
    }) : [],
    AssetId: dataItem?.AssetId,
    Series_Id: selectedSeriesId,
    SeasonCode: dataItem?.SeasonCode,
    Genres: dataItem?.Genres?.length > 0 ? dataItem.Genres.map(x => {
      return {
        _id: x._id,
        Description: x.Description,
      }
    }) : [],
    SubGenres: dataItem?.SubGenres?.length > 0 ? dataItem.SubGenres.map(x => {
      return {
        _id: x._id,
        Description: x.Description,
      }
    }) : [],
    MediaType: dataItem?.MediaType ? { _id: dataItem?.MediaType?._id, SID: dataItem?.MediaType?.SID, Description: dataItem?.MediaType?.Description } : {},
    MediaSubType: dataItem?.MediaSubType ? { _id: dataItem?.MediaSubType?._id, SID: dataItem?.MediaSubType?.SID, Description: dataItem?.MediaSubType?.Description } : {},
    Provider: dataItem.Provider?._id ? { _id: dataItem.Provider?._id, Description: dataItem.Provider?.Description } : {},
    ProductionYear: dataItem?.ProductionYear,
    Keywords: dataItem?.Keywords,
    PGRating: dataItem?.PGRating && Object.keys(dataItem?.PGRating).length > 0 ? {
      _id: dataItem?.PGRating?._id,
      Description: dataItem?.PGRating?.Description
    } : {},
    Languages: dataItem?.Languages?.length > 0 ? dataItem.Languages.map(x => {
      return {
        _id: x._id,
        Description: x.Description,
        ISOCode: x.ISOCode
      }
    }) : [],
    IsOttAsset: isOttAsset ?? false,
    Archive: dataItem?.Archive ?? false,
    IsCatchUp: dataItem?.IsCatchUp ?? false,
    Transmission: dataItem?.Transmission?._id ? dataItem?.Transmission?._id : null,
    // TargetGroup: dataItem?.TargetGroup?._id ? { _id: dataItem?.TargetGroup?._id, Name: dataItem?.TargetGroup?.Name } : {},
    checkDuplicate: true,
    //CastAndCrew: castAndCrew,
    CastAndCrew: castAndCrew?.length > 0 ? castAndCrew?.map((x) => {
      return {
        Name: x?.Name,
        CastType: { _id: x?.CastType?._id, Description: x?.CastType?.Description },
        Language: {
          _id: x?.Language?._id,
          ISOCode: x?.Language?.ISOCode,
          Description: x?.Language?.Description
        }
      }
    }) : [],
    Categories: dataItem?.Categories && dataItem?.Categories?.length > 0 ? dataItem?.Categories?.map((item) => {
      return {
        _id: item?._id,
        Name: item?.Name,
        parent: item?.parent
      }
    }) : [],
    Extension: dataItem?.Extension ?? {},
    dynamicField: dataItem?.dynamicField ?? {},
    DubbedLanguages: dataItem?.DubbedLanguages?.length > 0 ? dataItem.DubbedLanguages.map(x => {
      return {
        _id: x._id,
        Description: x.Description,
        ISOCode: x.ISOCode
      }
    }) : [],
    CustomTitle: dataItem?.CustomTitle ? {
      Title1: dataItem?.CustomTitle?.Title1,
      Title2: dataItem?.CustomTitle?.Title2,
    } : {},
    Country: dataItem?.Country && Object.keys(dataItem?.Country).length > 0 ? {
      _id: dataItem?.Country?._id,
      Description: dataItem?.Country?.Description,
      Code: dataItem?.Country?.Code
    } : {},
    ShortTitle: dataItem?.ShortTitle,
    CustomShortTitle: dataItem?.CustomShortTitle,
    CustomDescription: dataItem?.CustomDescription,
    WorkingTitle: dataItem?.WorkingTitle,
    DealReference: dataItem?.DealReference,
    //03-07-2025 : NEED TO CHECK MEDIA WHILE SAVING IF IT ALREADY EXISTS WITH SAME TITLE AND NOT ARCHIVED ( IF IT IS ARCHIVED STATE USER CAN CREATE WITH THE SAME TITLE )
    query: [["Title", "=", dataItem?.Title], ['SeasonNumber', '=', dataItem?.SeasonNumber], ["Archive", "=", false]]
  }

  return finalData;
}

DataHelper.saveMediaEpisodeLocalizationEntity = (dataItem = {}, mediaEpisode = {}) => {
  let finalData = {
    _id: dataItem?._id,
    SID: dataItem?.SID ?? 0,
    MediaEpisodeSID: mediaEpisode?.SID,
    MediaEpisode_id: mediaEpisode?._id,
    Language: dataItem?.Language && Object.keys(dataItem?.Language)?.length > 0 ? { _id: dataItem?.Language?._id, Description: dataItem?.Language?.Description, ISOCode: dataItem?.Language?.ISOCode } : {},
    Title: dataItem?.Title,
    EpisodeTitle: dataItem?.EpisodeTitle,
    ShortTitle: dataItem?.ShortTitle,
    Description: dataItem?.Description,
    Genres: dataItem?.Genres?.length > 0 ? dataItem.Genres.map(dataItem => {
      return {
        _id: dataItem._id,
        Description: dataItem.Description,
      }
    }) : [],
    SubGenres: dataItem?.SubGenres?.length > 0 ? dataItem.SubGenres.map(dataItem => {
      return {
        _id: dataItem._id,
        Description: dataItem.Description,
      }
    }) : [],
    MetaData: DataHelper.saveMetaDataEntity(dataItem.MetaData, mediaEpisode),
  };
  return finalData;
}

DataHelper.saveMediaEpisodeEntity = (dataItem = {}, mediaCategory = {}, isOttAsset = false) => {

  const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);


  //03-07-2025 : NEED TO CHECK MEDIA WHILE SAVING IF IT ALREADY EXISTS WITH SAME TITLE AND NOT ARCHIVED ( IF IT IS ARCHIVED STATE USER CAN CREATE WITH THE SAME TITLE )
  let duplicateCheckQuery = company?.segByRc ?
    [["Title", "=", dataItem?.Title], ["ReferenceCode", "=", dataItem?.ReferenceCode], ["Archive", "=", false]] :
    [["Title", "=", dataItem?.Title], ["MediaCategory.SID", "=", dataItem?.MediaCategory?.SID], ["Archive", "=", false], ["AssetId", "=", dataItem?.AssetId]];

  if (mediaCategory?.SID == MEDIACATEGORIES.Episode) {
    duplicateCheckQuery = [...duplicateCheckQuery, ["EpisodeTitle", "=", dataItem?.EpisodeTitle], ["EpisodeNumber", "=", dataItem?.EpisodeNumber]];
  }

  let finalData = {
    _id: dataItem?._id,
    SID: parseInt(dataItem?.SID),
    Title: dataItem?.Title,
    EpisodeTitle: mediaCategory.SID == MEDIACATEGORIES.Episode ? dataItem?.EpisodeTitle : '',
    Description: dataItem?.Description,
    Content: dataItem?.Content ? { _id: dataItem?.Content?._id, SID: dataItem?.Content?.SID, Description: dataItem?.Content?.Description } : {},
    AssetId: dataItem?.AssetId,
    MediaCategory: dataItem?.MediaCategory ? { _id: dataItem?.MediaCategory?._id, Description: dataItem?.MediaCategory?.Description, SID: dataItem?.MediaCategory?.SID, isLong: dataItem?.MediaCategory?.isLong } : {},
    MediaCategoryType: dataItem?.MediaCategoryType ? { _id: dataItem?.MediaCategoryType?._id, Description: dataItem?.MediaCategoryType?.Description, SID: dataItem?.MediaCategoryType?.SID, MediaCategorySID: dataItem?.MediaCategoryType?.MediaCategorySID } : {},
    MediaSubCategoryType: dataItem?.MediaSubCategoryType ? { _id: dataItem?.MediaSubCategoryType?._id, Description: dataItem?.MediaSubCategoryType?.Description, SID: dataItem?.MediaSubCategoryType?.SID, MediaCategorySID: dataItem?.MediaSubCategoryType?.MediaCategorySID } : {},
    ImageUrl: dataItem?.ImageUrl ? dataItem?.ImageUrl : 'https://i.postimg.cc/j5PsF5jZ/defaultmovie.png',
    Duration: typeof dataItem?.Duration == 'string' ? utility.convertStringWithFramesToMilliseconds(dataItem?.Duration) : dataItem?.Duration,
    ReferenceCode: dataItem?.ReferenceCode ? dataItem?.ReferenceCode : dataItem?.AssetId,
    IMDbID: dataItem?.IMDbID ?? '',
    ReleaseDate: dataItem?.ReleaseDate ?? '',
    Genres: dataItem?.Genres?.length > 0 ? dataItem.Genres.map(x => {
      return {
        _id: x._id,
        Description: x.Description,
      }
    }) : [],
    SubGenres: dataItem?.SubGenres?.length > 0 ? dataItem.SubGenres.map(x => {
      return {
        _id: x._id,
        Description: x.Description,
      }
    }) : [],
    MediaType: dataItem?.MediaType && Object.keys(dataItem?.MediaType).length > 0 ? { _id: dataItem?.MediaType?._id, SID: dataItem?.MediaType?.SID, Description: dataItem?.MediaType?.Description } : {},
    MediaSubType: dataItem?.MediaSubType && Object.keys(dataItem?.MediaSubType).length > 0 ? { _id: dataItem?.MediaSubType?._id, SID: dataItem?.MediaSubType?.SID, Description: dataItem?.MediaSubType?.Description } : {},
    Formats: dataItem?.Formats,
    IsOttAsset: isOttAsset ?? false,
    Archive: dataItem?.Archive ?? false,
    IsLive: dataItem?.IsLive ?? false,
    IsMusic: dataItem?.IsMusic ?? false,
    MusicCategory: dataItem?.MusicCategory ?? {},
    Marker: dataItem?.Marker ?? [],
    CustomTitle: dataItem?.CustomTitle ? {
      Title1: dataItem?.CustomTitle?.Title1,
      Title2: dataItem?.CustomTitle?.Title2,
    } : {},
    CustomEpisodeTitle: dataItem?.CustomEpisodeTitle ? {
      Title1: dataItem?.CustomEpisodeTitle?.Title1,
      Title2: dataItem?.CustomEpisodeTitle?.Title2,
    } : {},
    ShortTitle: dataItem?.ShortTitle,
    CustomShortTitle: dataItem?.CustomShortTitle,
    CustomDescription: dataItem?.CustomDescription,
    Transmission: dataItem?.Transmission?._id ? dataItem?.Transmission?._id : null,
    TargetGroup: dataItem?.TargetGroup ? { _id: dataItem?.TargetGroup?._id, Name: dataItem?.TargetGroup?.Name } : {},
    AlwaysLive: dataItem?.AlwaysLive ?? false,
    Provider: dataItem?.Provider?._id ? { _id: dataItem?.Provider?._id, Description: dataItem?.Provider?.Description } : {},
    // WorkingTitle: DataHelper.getWorkingTitle({ customTitle2: dataItem?.CustomTitle?.Title2, title: dataItem?.Title, seasonNumber: dataItem?.SeasonNumber, episodeNumber: dataItem?.EpisodeNumber, pgRating: dataItem?.PGRating?.Description, dealReference: dataItem?.DealReference }),
    WorkingTitle: dataItem?.WorkingTitle,
    DealReference: dataItem?.DealReference,
    checkDuplicate: true,
    query: duplicateCheckQuery,
  }

  if (finalData.MediaCategory.SID == MEDIACATEGORIES.Episode) {
    finalData.EpisodeNumber = dataItem?.EpisodeNumber ?? 1;
    finalData.SeasonNumber = dataItem?.SeasonNumber ?? 1;
  }

  return finalData;
}

DataHelper.saveMetaDataEntity = (dataItem = {}, mediaEpisode = {}) => {

  console.log("ded")

  let finalData = {
    MediaEpisodeSID: mediaEpisode.SID,
    MediaEpisode_id: mediaEpisode._id,

    PGRating: dataItem?.PGRating ? {
      _id: dataItem?.PGRating?._id,
      Description: dataItem?.PGRating?.Description
    } : {},

    CensorRating: dataItem?.CensorRating ? {
      _id: dataItem?.CensorRating?._id,
      Description: dataItem?.CensorRating?.Description
    } : {},

    MediaTechnicalPrototype: dataItem?.MediaTechnicalPrototype ? {
      _id: dataItem?.MediaTechnicalPrototype?._id,
      Description: dataItem?.MediaTechnicalPrototype?.Description,
    } : {},

    Languages: dataItem?.Languages?.length > 0 ? dataItem.Languages.map((x) => {
      return {
        _id: x?._id,
        Description: x?.Description,
        ISOCode: x.ISOCode
      }
    }) : [],

    Keywords: dataItem?.Keywords ?? '',

    ProductionYear: dataItem?.ProductionYear ?? '',

    Synopsis: dataItem?.Synopsis?.length > 0 ? dataItem.Synopsis.map((x) => {
      return {
        Synopsis: x?.Synopsis,
        Language: {
          _id: x.Language?._id,
          ISOCode: x.Language?.ISOCode,
          GoogleApiCode: x.Language?.GoogleApiCode,
          Description: x.Language?.Description
        },
        Type: x?.Type
      }
    }) : [],

    CastAndCrew: dataItem?.CastAndCrew?.length > 0 ? dataItem?.CastAndCrew?.map((x) => {
      return {
        Name: x.Name,
        CastType: { _id: x.CastType._id, Description: x.CastType?.Description },
        Language: {
          _id: x.Language?._id,
          ISOCode: x.Language?.ISOCode,
          Description: x.Language?.Description
        }
      }
    }) : [],

    Categories: dataItem?.Categories?.length > 0 ? dataItem?.Categories?.map((x) => {
      return {
        _id: x._id,
        Name: x.Name,
        parent: x.parent
      }
    }) : [],

    AudioTrack: dataItem?.AudioTrack?.length > 0 ? dataItem?.AudioTrack.map((x) => {
      return {
        Language: {
          "_id": x.Language?._id,
          "Description": x.Language?.Description,
        },
        TrackNumber: x?.TrackNumber
      }
    }) : [],

    MamID: dataItem?.MamID ?? '',

    CensorshipDetail: dataItem?.CensorshipDetail ? dataItem?.CensorshipDetail : [],

    dynamicField: dataItem?.dynamicField ?? {},
    DubbedLanguages: dataItem?.DubbedLanguages?.length > 0 ? dataItem.DubbedLanguages.map((x) => {
      return {
        _id: x?._id,
        Description: x?.Description,
        ISOCode: x.ISOCode
      }
    }) : [],
    Extension: dataItem?.Extension ?? {},
    Country: dataItem?.Country && Object.keys(dataItem?.Country).length > 0 ? {
      _id: dataItem?.Country?._id,
      Description: dataItem?.Country?.Description,
      Code: dataItem?.Country?.Code
    } : {}
  }

  if (dataItem?._id) {
    finalData._id = dataItem?._id;
  }

  if (dataItem?.SID) {
    finalData.SID = dataItem?.SID;
  }

  return finalData;
}

const getMediaEpisodeInShortFormPublishing = (data) => {

  if (!data || data?.length == 0) return [];

  let finalData = data.map((x) => {
    return {
      SID: x?.SID,
      PublishStartDate: x?.PublishStartDate,
      PublishStartDateTime: x?.PublishStartDateTime,
      PublishEndDate: x?.PublishEndDate,
      PublishEndDateTime: x?.PublishEndDateTime,
      TimeBound: x?.TimeBound,
      PublishingSource: x?.PublishingSource,
      PlatformType: x?.PlatformType && Object.keys(x?.PlatformType).length > 0 ? {
        SID: x?.PlatformType?.SID,
        Description: x?.PlatformType?.Description,
      } : {},
      Channel: x?.Channel && x?.Channel?.length > 0 ? x?.Channel.map((y) => {
        return {
          _id: y._id,
          SID: y.SID,
          FullChannelName: y.FullChannelName
        }
      }) : [],
      Days: x.Days,
      TBA: x.TBA ?? false,
      IsExclusive: x.IsExclusive ?? false,
      ExclusiveStartDate: x.IsExclusive ? x.ExclusiveStartDate : null,
      ExclusiveEndDate: x.IsExclusive ? x.ExclusiveEndDate : null
    }
  });
  return finalData;
}


DataHelper.saveMediaEpisodeIsShortFormEntity = (dataItem) => {
  let finalData = {
    _id: dataItem?._id,
    SID: dataItem?.SID,
    AssetId: dataItem?.AssetId,
    Title: dataItem?.Title,
    Content: dataItem?.Content && Object.keys(dataItem?.Content).length > 0 ? {
      _id: dataItem?.Content?._id,
      SID: dataItem?.Content?.SID,
      Description: dataItem?.Content?.Description
    } : {},
    Description: dataItem?.Description,
    MediaCategory: dataItem?.MediaCategory && Object.keys(dataItem?.MediaCategory).length > 0 ? {
      _id: dataItem?.MediaCategory?._id,
      Description: dataItem?.MediaCategory?.Description,
      SID: dataItem?.MediaCategory?.SID,
      isLong: dataItem?.MediaCategory?.isLong
    } : {},
    MediaCategoryType: dataItem?.MediaCategoryType && Object.keys(dataItem?.MediaCategoryType).length > 0 ? {
      _id: dataItem?.MediaCategoryType?._id,
      Description: dataItem?.MediaCategoryType?.Description,
      SID: dataItem?.MediaCategoryType?.SID,
      MediaCategorySID: dataItem?.MediaCategoryType?.MediaCategorySID
    } : {},
    Version: dataItem?.Version && Object.keys(dataItem?.Version).length > 0 ? {
      _id: dataItem?.Version?._id,
      Name: dataItem?.Version?.Name
    } : {},
    Variance: dataItem?.Variance && Object.keys(dataItem?.Variance).length > 0 ? {
      _id: dataItem.Variance._id,
      Description: dataItem.Variance.Description
    } : {},
    Genres: dataItem?.Genres && dataItem?.Genres?.length > 0 ? dataItem.Genres.map((x) => {
      return { _id: x._id, Description: x.Description }
    }) : [],
    TcIn: utility.convertStringWithFramesToMilliseconds(dataItem?.TcIn ?? "00:00:00:00"),
    TcOut: utility.convertStringWithFramesToMilliseconds(dataItem?.TcOut ?? "00:00:00:00"),
    Duration: utility.convertStringWithFramesToMilliseconds(dataItem?.Duration ?? "00:00:00:00"),
    ReleaseDate: dataItem?.ReleaseDate ? new Date(moment(dataItem.ReleaseDate).format("YYYY-MM-DD HH:mm:ss")).getTime() : '',
    ImageUrl: dataItem?.ImageUrl ? dataItem?.ImageUrl : 'https://i.postimg.cc/j5PsF5jZ/defaultmovie.png',
    RestrictedGenres: dataItem?.RestrictedGenres && dataItem?.RestrictedGenres?.length > 0 ? dataItem?.RestrictedGenres?.map((x) => {
      return { _id: x._id, Description: x.Description }
    }) : [],
    Archive: dataItem.Archive ?? false,
    Publishings: getMediaEpisodeInShortFormPublishing(dataItem?.Publishings),
    IsBreak: dataItem?.IsBreak ?? false,
    TXReady: dataItem.TXReady ? true : false,
    Brand: dataItem?.Brand && Object.keys(dataItem?.Brand).length > 0 ? {
      _id: dataItem?.Brand?._id,
      Name: dataItem?.Brand?.Name
    } : {},
    Artist: dataItem?.Artist,
    BroadcasterId: dataItem?.BroadcasterId,
    Media: dataItem?.Media,
    Product: dataItem?.Product && Object.keys(dataItem?.Product).length > 0 ? {
      _id: dataItem?.Product?._id,
      Name: dataItem?.Product?.Name
    } : {},
    Targets: dataItem?.Targets,
    MetaData: DataHelper.saveMetaDataEntity(dataItem?.MetaData, dataItem),
    PrimaryChannel: dataItem?.PrimaryChannel && Object.keys(dataItem?.PrimaryChannel).length > 0 ? { _id: dataItem?.PrimaryChannel?._id, SID: dataItem?.PrimaryChannel?.SID, FullChannelName: dataItem?.PrimaryChannel?.FullChannelName } : {},
    Transmission: dataItem?.Transmission?._id ? dataItem?.Transmission?._id : null,
    Record: dataItem?.Record ?? "",
    Publisher: dataItem?.Publisher ?? "",
    Priority: dataItem?.Priority && Object.keys(dataItem?.Priority).length > 0 ? {
      _id: dataItem?.Priority?._id,
      Description: dataItem?.Priority?.Description
    } : {},
    Mam: dataItem?.Mam ?? {},
    Advertiser: dataItem?.Advertiser,
    TimeRestriction: dataItem?.TimeRestriction?.length > 0 ? dataItem.TimeRestriction.map(item => ({
      From: utility.convertShortTimeStringToMilliSeconds(item.From),
      To: utility.convertShortTimeStringToMilliSeconds(item.To)
    })) : []
  }
  return finalData;
}

DataHelper.savePlanningFilterTemplate = (dataItem) => {
  if (!dataItem) return {};
  let finalData = {
    Genres: dataItem?.Genres && dataItem?.Genres?.length > 0 ? dataItem.Genres.map((x) => { return { _id: x._id, Description: x.Description } }) : [],
    PGRating: dataItem?.PGRating && dataItem?.PGRating?.length > 0 ? dataItem.PGRating.map((x) => { return { _id: x._id, Description: x.Description } }) : [],
    MediaCategory: dataItem?.MediaCategory && dataItem?.MediaCategory?.length > 0 ? dataItem?.MediaCategory.map((x) => { return { _id: x._id, Description: x.Description, SID: x.SID, isLong: x.isLong } }) : [],
    Channel: dataItem?.Channel && dataItem?.Channel?.length > 0 ? dataItem?.Channel.map((x) => { return { _id: x._id, FullChannelName: x.FullChannelName, SID: x.SID } }) : [],
    Exhibitions: dataItem?.Exhibitions,
    ReleaseYear: dataItem?.ReleaseYear && dataItem?.ReleaseYear != "" ? parseInt(dataItem?.ReleaseYear) : "",
    Language: dataItem?.Language && dataItem?.Language?.length > 0 ? dataItem.Language.map((x) => { return { _id: x._id, Description: x.Description } }) : [],
    CastName: dataItem?.CastName,
    CastType: dataItem?.CastType && Object.keys(dataItem?.CastType).length > 0 ? {
      _id: dataItem?.CastType?._id,
      Description: dataItem?.CastType?.Description
    } : {},
    isLive: dataItem?.isLive,
    CreatedFrom: dataItem?.CreatedFrom,
    CreatedTo: dataItem?.CreatedTo,
    publishingStartDate: dataItem?.publishingStartDate,
    publishingEndDate: dataItem?.publishingEndDate,
    contentCategory: dataItem?.contentCategory && dataItem?.contentCategory?.length > 0 ? dataItem.contentCategory.map((x) => { return { _id: x._id, Name: x.Name } }) : [],
    platforms: (dataItem?.isNonLinear && dataItem?.platforms && dataItem?.platforms?.length > 0) ? dataItem.platforms.map((x) => { return { _id: x._id, Description: x.Description } }) : [],
    regions: (dataItem?.isNonLinear && dataItem?.regions && dataItem?.regions?.length > 0) ? dataItem.regions.map((x) => { return { _id: x._id, Description: x.Description } }) : [],
    VodTypes: (dataItem?.isNonLinear && dataItem?.VodTypes && dataItem?.VodTypes?.length > 0) ? dataItem.VodTypes.map((x) => { return { _id: x._id, Name: x.Name } }) : [],
    isNonLinear: dataItem?.isNonLinear ?? false,
    MinimumDaysGapInPrimaryEvent: dataItem?.MinimumDaysGapInPrimaryEvent && parseInt(dataItem?.MinimumDaysGapInPrimaryEvent),
    Provider: (dataItem?.isNonLinear && dataItem?.Provider && dataItem?.Provider?.length > 0) ? dataItem.Provider.map((x) => { return { _id: x._id, Description: x.Description } }) : [],
    Transmission: dataItem?.Transmission ? dataItem?.Transmission : null,
    CastAndCrew: dataItem?.CastAndCrew ? dataItem?.CastAndCrew : [],
    isExpired: dataItem?.isExpired ?? false,
    Versions: dataItem?.Versions ?? null,
    MamAssets: dataItem?.MamAssets ?? null,
    Offers: dataItem?.Offers ?? null,
    MediaSubCategoryType: dataItem?.MediaSubCategoryType && dataItem?.MediaSubCategoryType?.length > 0 ? dataItem?.MediaSubCategoryType.map((x) => { return { _id: x?._id, Description: x?.Description, SID: x?.SID, MediaCategorySID: x?.MediaCategorySID } }) : [] 
  }
  return finalData;
}

DataHelper.saveOttFilterTemplate = (dataItem) => {
  if (!dataItem) return {};
  let finalData = {
    AssetType: (dataItem?.AssetType && Object.keys(dataItem?.AssetType).length > 0 && dataItem?.AssetType?._id != 0) ? { _id: dataItem?.AssetType?._id, Description: dataItem?.AssetType?.Description } : {},
    Provider: (dataItem?.Provider && Object.keys(dataItem?.Provider).length > 0 && dataItem?.Provider?._id != 0) ? { _id: dataItem?.Provider?._id, Description: dataItem?.Provider?.Description } : {},
    AccessLevel: dataItem?.AccessLevel && Object.keys(dataItem?.AccessLevel)?.length > 0 ? { _id: dataItem?.AccessLevel?._id, Description: dataItem?.AccessLevel?.Description } : {},
    VodType: (dataItem?.VodType && Object.keys(dataItem?.VodType).length > 0 && dataItem?.VodType?._id != 0) ? { _id: dataItem?.VodType?._id, Name: dataItem?.VodType?.Name } : {},
    CreatedFrom: dataItem?.CreatedFrom,
    CreatedTo: dataItem?.CreatedTo,
    Genres: dataItem?.Genres && dataItem?.Genres?.length > 0 ? dataItem.Genres.map((x) => { return { _id: x._id, Description: x.Description } }) : [],
    PGRating: dataItem?.PGRating && dataItem?.PGRating?.length > 0 ? dataItem.PGRating.map((x) => { return { _id: x._id, Description: x.Description } }) : [],
    ReleaseYear: dataItem?.ReleaseYear && dataItem?.ReleaseYear != "" ? parseInt(dataItem?.ReleaseYear) : "",
    MediaCategory: dataItem?.MediaCategory && dataItem?.MediaCategory?.length > 0 ? dataItem?.MediaCategory.map((x) => { return { _id: x._id, Description: x.Description, SID: x.SID, isLong: x.isLong } }) : [],
    Languages: dataItem?.Languages && dataItem?.Languages?.length > 0 ? dataItem.Languages.map((x) => { return { _id: x._id, Description: x.Description } }) : [],
    CastAndCrews: dataItem?.CastAndCrews && dataItem?.CastAndCrews?.length > 0 ? dataItem.CastAndCrews.map((x) => { return { _id: x._id, Description: x.Description } }) : [],
    Segments: (dataItem?.Segments && Object.keys(dataItem?.Segments).length > 0 && dataItem?.Segments?._id != 0) ? { _id: dataItem?.Segments?._id, Description: dataItem?.Segments?.Description } : {},
    ContentCategories: dataItem?.ContentCategories && dataItem?.ContentCategories?.length > 0 ? dataItem.ContentCategories.map((x) => { return { _id: x._id, Name: x.Name, parent: x.parent } }) : [],
  }
  return finalData;
}

// Need to use this func in series, season, movie, program
DataHelper.getMediaOttAssetsEntity = (assetDataItem, mediaEpisodeEntity) => {
  let finalData = {
    _id: assetDataItem._id,
    SID: assetDataItem.SID,
    Title: mediaEpisodeEntity.Title,
    Description: mediaEpisodeEntity.Title,
    TBA: assetDataItem.TBA ?? false,
    StartDate: assetDataItem.StartDate ? new Date(assetDataItem.StartDate).getTime() : new Date(moment(new Date()).format('YYYY-MM-DD')).getTime(),
    EndDate: assetDataItem.EndDate ? new Date(assetDataItem.EndDate).getTime() : new Date(moment(new Date()).add(1, 'M').format('YYYY-MM-DD')).getTime(),
    OttAssetTypeSID: ASSETTYPE['Media Asset'],
    VodTypes: {
      _id: assetDataItem.VodTypes._id,
      SID: assetDataItem.VodTypes.SID,
      Name: assetDataItem.VodTypes.Name
    },
    Provider: assetDataItem.Provider ? (typeof assetDataItem.Provider == "string") ? assetDataItem.Provider : assetDataItem.Provider?._id : "",
    Archive: assetDataItem.Archive ?? false,
    Source: { _id: mediaEpisodeEntity._id, SID: mediaEpisodeEntity.SID, Title: mediaEpisodeEntity.Title, MediaCategory: mediaEpisodeEntity.MediaCategory, entityName: mediaEpisodeEntity?.MediaCategory?.SID == MEDIACATEGORIES.Series ? ENTITYNAME.Series : mediaEpisodeEntity?.MediaCategory?.SID == MEDIACATEGORIES.Season ? ENTITYNAME.Season : ENTITYNAME.MediaEpisode },
    routeType: typeof assetDataItem.routeType === 'object' ? assetDataItem.routeType.ID : assetDataItem.routeType,
    page_id: typeof assetDataItem.page_id === 'object' ? assetDataItem.page_id._id : assetDataItem.page_id,
    Videos: assetDataItem.Videos ?? [],
    Posters: assetDataItem.Posters ?? [],
    RentalRetailPrice: assetDataItem.VodTypes.Name == 'TVOD' ? assetDataItem.RentalRetailPrice : 0,
    RentalWholesalePrice: assetDataItem.VodTypes.Name == 'TVOD' ? assetDataItem.RentalWholesalePrice : 0,
    WebAssets: assetDataItem?.WebAssets ? assetDataItem?.WebAssets?._id : null,
    accessLevel: assetDataItem?.accessLevel?._id ?? ACCESS_LEVEL.Both,
    Segments: (assetDataItem?.Segments && assetDataItem?.Segments?.length > 0) ? assetDataItem?.Segments?.map((x) => {
      return {
        _id: x?._id,
        Description: x?.Description
      }
    }) : []
  }
  return finalData;
}

DataHelper.getMediaFilterQuery = (data = {}, entityName = ENTITYNAME.MediaEpisode) => {
  if (Object.keys(data).length == 0) {
    return [];
  }
  let mediaCategoryFilter = data?.MediaCategory && data?.MediaCategory?.length != 0 ? [['MediaCategory.SID', 'in', data.MediaCategory.map((item) => item.SID)]] : [];
  let mediaSubCategoryTypeFilter = data?.MediaSubCategoryType && data?.MediaSubCategoryType?.length != 0 ? [['MediaSubCategoryType.SID', 'in', data.MediaSubCategoryType.map((item) => item.SID)]] : [];
  let genresFilter = data?.Genres && data?.Genres?.length != 0 ? [['Genres._id', 'in', data.Genres.map((item) => item._id)]] : [];
  let isLiveFilter = data?.isLive ? [["IsLive", '=', true]] : [];
  let releaseYearFilter = data?.ReleaseYear && data?.ReleaseYear != "" ? [["ReleaseDate", ">=", new Date(`${data.ReleaseYear}-01-01`).getTime()], ["ReleaseDate", "<=", new Date(`${data.ReleaseYear}-12-31`).getTime()]] : [];
  let productionYearFilter = data?.ReleaseYear && data?.ReleaseYear != "" ? [["Metadata.ProductionYear", "=", data?.ReleaseYear?.toString()]] : [];
  let channelFilter = data?.Channel && data?.Channel?.length != 0 ? [['Publishings.Channel.SID', 'in', data.Channel.map((item) => item.SID)]] : [];
  let createdFromFilter = data?.CreatedFrom ? [["addOn", ">=", utility.convertStringDatetoMilliseconds(data.CreatedFrom)]] : [];
  let createdToFilter = data?.CreatedTo ? [["addOn", "<=", utility.convertStringEndDateToMilliSeconds(data.CreatedTo)]] : [];
  let publishingDateFilter = (data?.publishingStartDate && data?.publishingEndDate) ? data?.isNonLinear ? [["Publishings", "elemMatch", { "PlatformType.SID": PLATFORMTYPE[1].SID, PublishStartDate: { "$lte": utility.convertStringEndDateToMilliSeconds(data.publishingEndDate) }, PublishEndDate: { "$gte": utility.convertStringDatetoMilliseconds(data.publishingStartDate) } }]] : [["Publishings", "elemMatch", { "PlatformType.SID": PLATFORMTYPE[0].SID, PublishStartDate: { "$lte": utility.convertStringEndDateToMilliSeconds(data.publishingEndDate) }, PublishEndDate: { "$gte": utility.convertStringDatetoMilliseconds(data.publishingStartDate) } }]] : [];
  let languagesFilter = data?.Language && data?.Language?.length > 0 ? [[entityName == ENTITYNAME.MediaEpisode ? 'Metadata.Languages._id' : 'Languages._id', "in", data?.Language?.map(x => x?._id)]] : [];
  let pgRatingsFilter = data?.PGRating && data?.PGRating?.length > 0 ? [[entityName == ENTITYNAME.MediaEpisode ? 'Metadata.PGRating._id' : 'PGRating._id', "in", data?.PGRating?.map(x => x?._id)]] : [];
  let contentCategoryFilter = data?.contentCategory && data?.contentCategory?.length > 0 ? [['Metadata.Categories._id', "in", data?.contentCategory?.map(x => x?._id)]] : [];
  let platformsFilter = data?.platforms && data?.platforms?.length > 0 ? [['Publishings.Platform._id', "in", data?.platforms?.map(x => x?._id)]] : [];
  let regionsFilter = data?.regions && data?.regions?.length > 0 ? [['Publishings.Region._id', "in", data?.regions?.map(x => x?._id)]] : [];
  let vodTypesFilter = data?.VodTypes && data?.VodTypes?.length > 0 ? [['OttAssets.VodTypes._id', "in", data?.VodTypes?.map(x => x?._id)]] : [];
  let nonLinearFilter = data?.isNonLinear ? [["IsOttAsset", "=", true]] : [];
  let providerFilter = data?.Provider && data?.Provider?.length > 0 ? [['OttAssets.Provider', "in", data?.Provider?.map(x => x?._id)]] : [];
  let transmissionFilter = data?.Transmission && Object.keys(data.Transmission).length > 0 && data.Transmission?._id != 0 ? [['Transmission', "=", data?.Transmission?._id]] : [];
  let isExpiredFilter = data?.isExpired ? [["MaxPublishEndDate", "<", new Date().getTime()]] : [];

  //VOD VERSION COUNT, MAM ASSET COUNT & OFFER COUNT 
  let versionCountFilter = data.hasVersions == undefined ? [] : data?.hasVersions ? [['Versions', ">", 0]] : [['Versions', "=", 0]];
  let mamAssetCountFilter = data.hasMamAssets == undefined ? [] : data?.hasMamAssets ? [['MamAssets', ">", 0]] : [['Versions', "=", 0]];
  let offerCountFilter = data.hasOffers == undefined ? [] : data?.hasMamAssets ? [['Offers', ">", 0]] : [['Versions', "=", 0]];
  let transmissionCountFilter = data.hasTransmissions == undefined ? [] : data?.hasTransmissions ? [['Trasmissions', ">", 0]] : [['Versions', "=", 0]];


  //CAST AND CREW FILTER
  let castAndCrewFilter = (data?.CastName && data?.CastName?.length > 0 && Object.keys(data.CastType).length > 0) ?
    [['Metadata.CastAndCrew', 'elemMatch', { Name: { $regex: data.CastName, $options: 'i' }, "CastType.Description": data.CastType.Description }]] :
    (data?.CastName && data?.CastName?.length > 0) ?
      [['Metadata.CastAndCrew', 'elemMatch', { Name: data.CastName, CastType: data.CastType }]] :
      (data.CastType && Object.keys(data.CastType).length > 0) ? [['Metadata.CastAndCrew', 'elemMatch', { "CastType.Description": data.CastType.Description }]] : [];
  let CastAndCrews = data?.CastAndCrews && data?.CastAndCrews?.length > 0 ? [['CastAndCrews._id', "in", data?.CastAndCrews?.map(x => x?._id)]] : [];

  let mediaCastAndCrewFilter = data?.CastAndCrew && data?.CastAndCrew?.length > 0 ?
    data.CastAndCrew.map((x) => {
      return ['Metadata.CastAndCrew', 'elemMatch', { Name: { $regex: x.CastName, $options: 'i' }, "CastType.Description": x.CastType.Description }]
    }) : []

  let finalFilterQuery = [
    ...mediaCategoryFilter,
    ...mediaSubCategoryTypeFilter,
    ...genresFilter,
    // ...releaseYearFilter, 
    ...isLiveFilter,
    ...productionYearFilter,
    ...castAndCrewFilter,
    ...createdFromFilter,
    ...createdToFilter,
    ...channelFilter,
    ...publishingDateFilter,
    ...languagesFilter,
    ...pgRatingsFilter,
    ...contentCategoryFilter,
    ...CastAndCrews,
    ...mediaCastAndCrewFilter,
    ...platformsFilter,
    ...regionsFilter,
    ...vodTypesFilter,
    ...nonLinearFilter,
    ...providerFilter,
    ...transmissionFilter,
    ...isExpiredFilter,
    ...versionCountFilter,
    ...mamAssetCountFilter,
    ...offerCountFilter,
    ...transmissionCountFilter
  ];

  return finalFilterQuery;

}

DataHelper.saveScheduleFilterTemplate = (dataItem) => {

  if (!dataItem) return {};
  let finalData = {
    MediaCategory: dataItem?.MediaCategory && dataItem?.MediaCategory?.length > 0 ? dataItem?.MediaCategory.map((x) => { return { _id: x._id, Description: x.Description, SID: x.SID, isLong: x.isLong } }) : [],
    MediaCategoryType: dataItem?.MediaCategoryType && dataItem?.MediaCategoryType?.length > 0 ? dataItem?.MediaCategoryType.map((x) => { return { _id: x._id, Description: x.Description, SID: x.SID, MediaCategorySID: x.MediaCategorySID } }) : [],
    Transmission: dataItem?.Transmission && Object.keys(dataItem?.Transmission).length > 0 ? dataItem?.Transmission : { _id: 0, Description: "All" },
    Channel: dataItem?.Channel && dataItem?.Channel?.length > 0 ? dataItem?.Channel.map((x) => { return { _id: x._id, SID: x.SID, FullChannelName: x.FullChannelName } }) : [],
    OnlyChannel: dataItem?.OnlyChannel ?? false,
    Brand: dataItem?.Brand && dataItem?.Brand?.length > 0 ? dataItem?.Brand.map((x) => { return { _id: x._id, Name: x.Name } }) : [],
    Product: dataItem?.Product && dataItem?.Product?.length > 0 ? dataItem?.Product.map((x) => { return { _id: x._id, Name: x.Name } }) : [],
    Duration: dataItem?.Duration && {
      ID: dataItem?.Duration?.ID ?? 0,
      Description: dataItem?.Duration?.Description ?? "",
      Operator: dataItem?.Duration?.Operator ?? "",
      Condition: typeof dataItem?.Condition === "string"
        ? utility.convertStringWithFramesToMilliseconds(dataItem.Condition)
        : dataItem?.Condition ?? 0,
    },
    IsDummy: dataItem?.IsDummy,
    CreatedFrom: dataItem?.CreatedFrom,
    CreatedTo: dataItem?.CreatedTo,
    isExpired: dataItem?.isExpired ?? false,
    templateName: dataItem?.templateName ?? "",
    Priority: dataItem?.Priority && Object.keys(dataItem?.Priority).length > 0 ? dataItem?.Priority : {}
  }
  return finalData;
}

DataHelper.getWorkingTitle = ({ customTitle2, title, seasonNumber, episodeNumber, pgRating, dealReference }) => {

  const hasEpisode = episodeNumber && episodeNumber > 0;

  const finalTitle = [customTitle2, title].find(v => v !== null && v !== undefined && v.toString().trim() !== "");

  return [
    finalTitle || null,
    (hasEpisode && seasonNumber) ? `S${seasonNumber}` : null,
    (hasEpisode && seasonNumber) ? `Ep.${episodeNumber}` : null,
    pgRating ? `[${pgRating}]` : null,
    dealReference ? `[${dealReference}]` : null,
  ].filter(Boolean).join(" ");
};

DataHelper.getMetaDataSegmentData = (metaData = {}) => {

  if (!metaData || Object.keys(metaData)?.length === 0) return {};

  const metaSegmentData = {
    _id: metaData?._id,
    Extension: {
      workingTitle: metaData?.Extension?.workingTitle,
      dealReference: metaData?.Extension?.dealReference
    }
  };
  return metaSegmentData;
}

DataHelper.fetchDefaultDealRights = async ({ user = {}, publishingSource }) => {
  // Fetch default deal rights
  const resDefaultDealRights = await API.getData(ENTITYNAME.UserDefaultDealRights, { query: [["user_id", "=", user?._id]] });
  const dealRights = resDefaultDealRights?.data?.[0];

  // Exit early if no default deal rights found
  if (!dealRights) return;

  // Fetch valid channels
  const channelRes = await API.getValidChannels();
  const validChannels = channelRes?.data || [];

  // Create valid channel id set
  const validChannelIds = new Set(
    validChannels.map(channel => channel?._id?.toString())
  );

  // Filter only channels that exist in validChannels
  const channels = (dealRights?.Channel || []).filter(channel =>
    validChannelIds.has(channel?._id?.toString())
  );

  return {
    ...dealRights,
    Publishing: {
      ...dealRights?.Publishing,
      PublishingSource: publishingSource,
      Channel: channels
    },
  };
}

DataHelper.getDefaultDealRights = ({ transmissionType = {}, isLinearUnlimitedRights = true, linearStartDate, linearEndDate, isNonLinearUnlimitedRights = true, nonLinearStartDate, nonLinearEndDate, channels = [], platforms = [], publishingSource }) => {

  let dealRights = [];

  const defaultStartDate = moment.utc().startOf('day').valueOf();
  const defaultEndDate = moment.utc().add(50, 'year').endOf('day').valueOf();

  if (channels?.length > 0) {
    let linearDealRights = {
      Channel: channels?.map(x => {
        return {
          _id: x._id,
          SID: x.SID,
          FullChannelName: x.FullChannelName
        }
      }) ?? [],
      PublishStartDate: isLinearUnlimitedRights ? defaultStartDate : moment.utc(linearStartDate).valueOf(),
      PublishEndDate: isLinearUnlimitedRights ? defaultEndDate : moment.utc(linearEndDate).valueOf(),
      PlatformType: PLATFORMTYPE[0],
      IsUnlimited: true,
      PublishingSource: publishingSource,
    }

    dealRights.push(linearDealRights);
  }

  if (platforms?.length > 0) {
    let linearDealRights = {
      Platform: platforms.map(x => {
        return {
          _id: x._id,
          SID: x.SID,
          Description: x.Description
        }
      }) ?? [],
      PublishStartDate: isNonLinearUnlimitedRights ? defaultStartDate : moment.utc(nonLinearStartDate).valueOf(),
      PublishEndDate: isNonLinearUnlimitedRights ? defaultEndDate : moment.utc(nonLinearEndDate).valueOf(),
      PlatformType: PLATFORMTYPE[1],
      PublishingSource: publishingSource,
      TransmissionType: transmissionType
    }

    dealRights.push(linearDealRights);

  }

  return dealRights;

}